import React from "react";
import { CDBIcon } from "cdbreact";
import { DatePicker, TimePicker } from "antd";
import dayjs from "dayjs";
import NavBarPeiix from '../../../components/NavBar.jsx';
import { useTransactions } from "../hooks/useTransactions";
import { ApprovedCard } from "../components/ApprovedCard.jsx";
import { FiltersPanel } from "../components/FiltersPanel";
import { TransactionsTable } from "../components/TransactionsTable.jsx";
import { LoadingOverlay } from "../components/LoadingOverlay";
import { PaginationComponent } from "../components/PaginationComponent";

export default function LinksView() {
  
  const {
    currentItems,
    totalPages,
    totalVentasPagina,
    uniqueBanks,
    uniqueMethods,
    loading,
    error,
    filtros,
    currentPage,
    showApproved,
    selectedColumns,
    setSelectedColumns,
    setShowApproved,
    handleInputChange,
    handleSelectChange,
    limpiarFiltros,
    handlePageChange
  } = useTransactions();

  // Función utilitaria estricta utilizando Day.js (estándar de Ant Design v5).
  // Esto previene los saltos erráticos de años y meses al interactuar con el calendario.
  const getValidDayjs = (dateString, format) => {
    if (!dateString) return null;
    const parsedDate = dayjs(dateString, format);
    return parsedDate.isValid() ? parsedDate : null;
  };

  const allColumns = [
    { key: 'ID', label: 'ID', property: 'id', alwaysShow: true },
    { key: 'Fecha', label: 'Fecha', property: 'created_at', alwaysShow: true },
    { key: 'No.Tarjeta', label: 'No.Tarjeta', property: 'last_four_digits', alwaysShow: true },
    { key: 'Subtotal', label: 'Subtotal', property: 'amount_subtotal_iva0', alwaysShow: true},
    { key: 'Banco', label: 'Banco', property: 'bank', alwaysShow: true },
    { key: 'Estado', label: 'Estado', property: 'status', alwaysShow: true },
    { key: 'CodigoAprobacion', label: 'Cód. Aprobación', property: 'approval_code' },
    { key: 'MarcaTarjeta', label: 'Marca Tarjeta', property: 'payment_brand' },
    { key: 'MetodoPago', label: 'Método de Pago', property: 'type' },
    { key: 'BancoProcesador', label: 'Banco Procesador', property: 'processor_bank_name' },
    { key: 'CodigoRespuesta', label: 'Cód. Respuesta', property: 'response_code' },
    { key: 'IDSmartlink', label: 'ID Smartlink', property: 'smart_link' },
    { key: 'Ticket', label: 'Ticket #', property: 'ticket_number' },
    { key: 'Referencia', label: 'Referencia', property: 'transaction_reference' },
    { key: 'Tipo', label: 'Tipo', property: 'type' },
    { key: 'DeclineCode', label: 'Cód. Rechazo', property: 'decline_code' },
    { key: 'DeclineMessage', label: 'Msj. Rechazo', property: 'decline_message' },
    { key: 'ProviderFixedAmount', label: 'Monto fijo', property: 'peiix_fixed_amount' },
    { key: 'IvaFixedAmountValue', label: 'Iva del monto fijo', property: 'iva_fixed_amount_value' },
    { key: 'Comision', label: 'Comisión', property: 'agreed_commission_value' },
    { key: 'Total', label: 'Total', property: 'trade_profit' },
    { key: "Nombre", label: "Nombre", property: "name", alwaysShow: true }, 
    { key: "Email", label: "Email", property: "email", alwaysShow: true }, 
    { key: "Direccion", label: "Direccion", property: "address", alwaysShow: true },  
    { key: "Telefono", label: "Telefono", property: "phone", alwaysShow: true },  
  ];
  
  const selectableColumns = allColumns.filter(col => !col.alwaysShow);

  if (error) return <p>Error: {error}</p>;

  const pickerStyle = {
    width: '100%',
    height: '40px',
    borderRadius: '6px',
    fontFamily: 'Montserrat, sans-serif'
  };

  return (
    <>
      <div className="Transacciones">
        <NavBarPeiix />
        <div className='navbar-container' style={{ padding: '40px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 className="fw-bold" style={{ color: '#3E3E3E', fontFamily: 'Montserrat, sans-serif', marginBottom: '0', display: 'flex', alignItems: 'center' }}>
            <CDBIcon icon="link" /> Transacciones de Links
          </h3>
        </div>
        
        <br />

        <ApprovedCard 
          totalVentasPagina={totalVentasPagina}
          showApproved={showApproved}
          setShowApproved={setShowApproved}
        />

        <br />

        <div style={{ padding: '0 40px', marginBottom: '25px' }}>
          <h4 style={{ fontWeight: 'bold', color: '#3E4144', fontFamily: 'Montserrat, sans-serif', marginBottom: '20px' }}>
            Filtros
          </h4>
          
          <div style={{ maxWidth: '550px' }}>
            <h6 style={{ fontWeight: 'bold', color: '#4A4A4A', marginBottom: '10px', fontFamily: 'Montserrat, sans-serif' }}>
              Rango
            </h6>
            
            <div style={{ 
              display: 'grid', 
              gridTemplateColumns: '1fr 1fr', 
              gap: '12px 16px' 
            }}>
              <DatePicker 
                placeholder="Fecha Inicio"
                style={pickerStyle}
                format="YYYY-MM-DD"
                value={getValidDayjs(filtros.fechaInicio, "YYYY-MM-DD")}
                onChange={(date, dateString) => handleSelectChange(dateString, "fechaInicio")}
              />
              <TimePicker 
                placeholder="Hora Inicio"
                style={pickerStyle}
                format="HH:mm"
                value={getValidDayjs(filtros.horaInicio, "HH:mm")}
                onChange={(time, timeString) => handleSelectChange(timeString, "horaInicio")}
              />
              
              <DatePicker 
                placeholder="Fecha Fin"
                style={pickerStyle}
                format="YYYY-MM-DD"
                value={getValidDayjs(filtros.fechaFin, "YYYY-MM-DD")}
                onChange={(date, dateString) => handleSelectChange(dateString, "fechaFin")}
              />
              <TimePicker 
                placeholder="Hora Fin"
                style={pickerStyle}
                format="HH:mm"
                value={getValidDayjs(filtros.horaFin, "HH:mm")}
                onChange={(time, timeString) => handleSelectChange(timeString, "horaFin")}
              />
            </div>
          </div>
        </div>

        <FiltersPanel 
          filtros={filtros}
          uniqueBanks={uniqueBanks}
          uniqueMethods={uniqueMethods}
          handleInputChange={handleInputChange}
          handleSelectChange={handleSelectChange}
          limpiarFiltros={limpiarFiltros}
          selectableColumns={selectableColumns}
          setSelectedColumns={setSelectedColumns}
        />
        
        <TransactionsTable 
          items={currentItems}
          selectedColumns={selectedColumns}
          allColumns={allColumns}
        />
        
        <br />
        <PaginationComponent 
          currentPage={currentPage}
          totalPages={totalPages}
          handlePageChange={handlePageChange}
        />
      </div>

      {loading && <LoadingOverlay />}
    </>
  );
}